import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { relationimportBatch } from '@/api/PMS/baseInformation/house';
import { relationExport } from '@/api/PMS/baseInformation/house';
import { formatJson } from '@/utils/index';
export default {
  props: ['showDialog'],
  data: function data() {
    return {
      files: [],
      fileList: [],
      status: '',
      templateId: '',
      customColor: '#36bfa3',
      isShowProgress: false,
      percentage: 0,
      uploadUrl: '',
      childData: {},
      disBtn: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.disBtn = false;
        this.files = [];
        this.fileList = [];
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
  },
  methods: {
    submitUpload: function submitUpload() {
      var _this = this;

      this.disBtn = true;

      if (this.fileList.length === 0) {
        this.Alert({
          alertType: 'error',
          message: '文件不能为空，请上传文件！'
        });
        this.disBtn = false;
        return;
      }

      this.isShowProgress = true;
      this.percentage = 0;
      var query = {
        fileId: this.fileList[0].fileId
      };
      relationimportBatch(query).then(function (res) {
        _this.percentage = 100;
        setTimeout(function () {
          _this.isShowProgress = false;
          _this.status = 'success';
        }, 500);

        if (res.data && res.data.code === 200) {
          _this.$emit('excelCancle', true);

          _this.$message({
            message: '导入成功',
            type: 'success',
            duration: 3000
          });
        }

        _this.disBtn = false;
      }).catch(function (err) {
        _this.percentage = 100;
        setTimeout(function () {
          _this.isShowProgress = false;
          _this.status = 'success';
        }, 500);

        if (err !== 'error') {
          _this.$message({
            message: err.message,
            type: 'error',
            duration: 3000
          });

          _this.disBtn = false;
        }

        _this.disBtn = false;
      });
    },
    // 移除excel文件
    handleRemove: function handleRemove(file, fileList) {
      var _this2 = this;

      var currentUrl = 0; // 获取当前删除文件的url

      if (file.response !== undefined) {
        // 文件是新增加的
        currentUrl = file.response.data[0].fileId;
      } else {
        // 文件是旧数据
        currentUrl = file.url;
      }

      this.fileList.forEach(function (item, index) {
        if (currentUrl === item.url) {
          _this2.fileList.splice(index, 1);

          return;
        }
      });
      this.files.forEach(function (col, n) {
        if (currentUrl === col.url) {
          _this2.fileList = []; // 因为此处限制了只能上传一个文件，所以可以直接清空

          return;
        }
      });
      this.disBtn = true;
    },
    // 下载模板
    handleDownload: function handleDownload() {
      var _this3 = this;

      relationExport().then(function (response) {
        _this3.relationlist = response.data.data;
      });
      this.$confirm('你确定要导出人房关系数据模板吗, 是否继续?', '提示').then(function () {
        // if (this.relationlist !== null && this.relationlist.length > 0) {
        Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/vendor/Export2Excel'));
        }).then(function (excel) {
          var multiHeader = [['房屋与人员关系导入', '房屋与人员关系导入', '房屋与人员关系导入', '房屋与人员关系导入', '房屋与人员关系导入', '房屋与人员关系导入', '备注： \n1、填写楼栋名称、单元名称和房屋名称，不可超出表格给出的范围，若需新增楼栋、单元和房屋，请现在楼栋、单元和房屋页面新增数据。\n2、人员身份只能选择以下三种：业主、家庭成员、租户。\n3、一个房屋只能绑定一个业主的一个手机号，但可绑定多个家庭成员和租户。\n4、表格字段不可修改。']];
          var tHeader = ['楼栋名称（不可更改）', '单元名称（不可更改）', '房屋名称（不可更改）', '人员身份（必填）', '人员姓名（必填）', '11位手机号码（必填）'];
          var fileterVal = ['buildingName', 'unintName', 'houseCode', '', '', ''];
          var data = formatJson(fileterVal, _this3.relationlist);
          var merges = ['A1:F1', 'G1:G1'];
          excel.export_json_to_excel({
            header: tHeader,
            multiHeader: multiHeader,
            data: data,
            merges: merges,
            filename: '人房绑定关系导入模板',
            autoWidth: true,
            bookType: 'xlsx',
            colsnum: 'G1'
          });
        }); // } else {
        //   this.Alert({ alertType: 'error', message: '暂无数据，无法导出！' })
        // }
      }); // const oa = document.createElement('a')
      // oa.href = '/mlxc/static/excel/relation.xlsx'
      // oa.download = '房屋与人员绑定关系导入'
      // var event = document.createEvent('MouseEvents')
      // event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, 0, null)
      // oa.dispatchEvent(event)
    },
    // 上传文件时判断文件类型
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.substring(file.name.lastIndexOf('.') + 1);
      extension = extension.toLowerCase();
      var fileFormatOK = extension === 'xls' || extension === 'xlsx';

      if (!fileFormatOK) {
        this.$message({
          message: '只支持上传 excel 格式文件!',
          type: 'error'
        });
        return false;
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u6BCF\u6B21\u6700\u591A\u53EA\u80FD\u5BFC\u5165\u4E00\u4E2A\u6587\u4EF6");
    },
    // 上传excel成功时获取服务器图片URL
    handleSuccess: function handleSuccess(response, file) {
      this.fileList.push({
        url: response.data[0].fileId,
        fileId: response.data[0].fileId,
        fileName: response.data[0].fileName,
        fileType: 1
      }); // this.fileList.push({ url: file.response.data[0].fileId, fileName: response.data[0].fileName, fileType: 1 })
    },
    handleError: function handleError(err, file, fileList) {
      var res = JSON.parse(err.message);
      this.$message({
        message: res.message,
        type: 'error'
      });
    },
    // 移除excel之前做的操作
    beforeRemove: function beforeRemove(file, fileList) {// return this.$confirm(`确定移除 ${ file.name }？`)
    },
    handCancle: function handCancle() {
      this.$emit('excelCancle', false);
    }
  }
};